/* jquery ready */
/* ************ */

(function($) {

  "use strict";

  let returnHasChanged = false;

  $(function() {

    // setup datepickers:
    // setting up datepickers inside the Drupal behavior
    // causes a JS-error in Safari (tested in Safari 14)

    let datepickerLocale = 'en';
    const pageLanguage = drupalSettings.path.currentLanguage;
    if(pageLanguage === 'nl' || pageLanguage === 'fr') {
      datepickerLocale = pageLanguage;
    }

    // Departure
    $("#request-form #edit-departure-date").flatpickr({
      altInput: true,
      altFormat: "d/m/Y",
      dateFormat: "Y-m-d",
      allowInput: true,
      locale: datepickerLocale,
      onChange: function(dateObj, dateStr) {

        if(!returnHasChanged) {

          // Return
          $('#request-form #edit-return-date').flatpickr({
            altInput: true,
            altFormat: "d/m/Y",
            dateFormat: "Y-m-d",
            allowInput: true,
            locale: datepickerLocale,
            defaultDate: [dateStr],
            onChange: function(dateObj, dateStr) {
              returnHasChanged = true;
            }
          });

        }

      }
    });

    // Return
    $("#request-form #edit-return-date").flatpickr({
      altInput: true,
      altFormat: "d/m/Y",
      dateFormat: "Y-m-d",
      allowInput: true,
      locale: datepickerLocale,
      onChange: function(dateObj, dateStr) {
        returnHasChanged = true;
      }
    });


  });

})(jQuery);

/* drupal behavior */
/* *************** */

(($) => {
  Drupal.behaviors.requestform = {

    attach: function(context, settings) {
      if (context !== document) {
        return;
      }

      this.init(context, settings);
    },

    init: function(context, settings) {
      if($('.request-page').length > 0) {

        // setup form controls:
        this.setupFormControls();

        // setup travel-program collapsible:
        this.setupProgramCollapsible();

        // setup travel-additional collapsible:
        this.setupAdditionalCollapsible();

        // setup mobile step summary:
        this.setupMobileStepSummary();

        // setup vehicle carousel:
        this.setupVehicleCarousel();
      }
    },

    setupFormControls: function(context) {

      // setup number spinners:
      // -> step 1: amount of travelers:
      new duo.NumberSpinner({
        inputSelector: '#edit-amount-of-travelers'
      });
      // -> step 2: coach selection:
      new duo.NumberSpinner({
        inputSelector: '.coach-option__action-block .form-number'
      });

      // setup time pickers:
      // -> set a correct placeholder value
      //    (that gets shown if the html5 time input is not supported)
      const $formTimePickers = $('#request-form #edit-departure-time, #request-form #edit-return-time');
      $formTimePickers.each(function(index, element) {
        $(element).attr('placeholder', Drupal.t('hh:mm'));
      });

      // setup departure timepicker:
      // -> even though the step value is set to "60", some browsers
      //    still display the seconds (or a placeholder) if they're
      //    available in the value that is set
      // -> get the hours and minutes of the timepicker and set
      //    them back without seconds
      const $departureTimePicker = $('#request-form #edit-departure-time');
      if($departureTimePicker.length > 0) {
        const departureTimeValue = $departureTimePicker.val();
        const departureTimeValueBits = departureTimeValue.split(':');
        const departureTimeHours = departureTimeValueBits[0];
        const departureTimeMinutes = departureTimeValueBits[1];
        if(departureTimeHours !== undefined && departureTimeMinutes !== undefined) {
          $departureTimePicker.val(departureTimeHours + ':' + departureTimeMinutes);
        }
      }
    },

    setupProgramCollapsible: function(context) {
      const self = this;

      const $tripProgramBlock = $(document).find('.trip-program-block');
      const $tripProgramBlockTitle = $tripProgramBlock.find('.trip-program-block__title');
      const $tripProgramBlockContent = $tripProgramBlock.find('.trip-program-block__content');

      // get a unique ID for the collapsible item:
      const itemId = 'program-collapsible-' + duo.Utils.uniqueId;

      // hide the content block and add unique ID:
      $tripProgramBlockContent.attr('hidden', 'true');
      $tripProgramBlockContent.attr('id', itemId);

      // add a toggle button to the header:
      const faqToggleButton = $(`<button type="button" class="trip-program-block__toggle-button js-tripprogram-toggle" aria-expanded="false" aria-controls="${ itemId }"></button>`);
      $tripProgramBlockTitle.prepend(`<div class="trip-program-block__toggle-button-icon">
        <svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true" focusable="false">
          <path class="trip-program-block__toggle-button-minus" d="M1.1 5.2c-.5 0-.8.3-.8.8s.4.8.8.8h9.8c.5 0 .8-.4.8-.8s-.4-.8-.8-.8H1.1z" />
          <path class="trip-program-block__toggle-button-plus" d="M6.8 1.1c0-.5-.4-.8-.8-.8s-.8.3-.8.8v4.1H1.1c-.5 0-.8.3-.8.8s.4.8.8.8h4.1v4.1c0 .5.4.8.8.8s.8-.4.8-.8V6.8h4.1c.5 0 .8-.4.8-.8s-.4-.8-.8-.8H6.8V1.1z" />
        </svg>
      </div>`);
      $tripProgramBlockTitle.wrapInner(faqToggleButton);

      // check sessionStorage to see if the collapsible should be opened:
      const collapsibleExistingStatus = sessionStorage.getItem('programcollapsible');
      if(collapsibleExistingStatus === 'true') {
        const $programToggle = $(document).find('.trip-program-block__toggle-button');
        const toggleButtonState = $programToggle.attr('aria-expanded');
        if(toggleButtonState === 'false') {
          self.toggleProgramCollapsible($programToggle);
        }
      }

      // toggle event:
      $(document).on('click.programcollapsible', '.js-tripprogram-toggle', function() {
        const $toggleButton = $(this);
        self.toggleProgramCollapsible($toggleButton);
      });
    },

    toggleProgramCollapsible: function($toggleButton) {
      const controlledElementId = $toggleButton.attr('aria-controls');
      const $controlledElement = $(`#${controlledElementId}`);
      const state = $toggleButton.attr('aria-expanded') === 'false' ? true : false;

      // -> set the expanded state on the button:
      $toggleButton.attr('aria-expanded', state);
      // -> set hidden state on the content:
      if(state) {
        $controlledElement.removeAttr('hidden');
      } else {
        $controlledElement.attr('hidden', 'true');
      }
      // -> save state in sessionStorage:
      sessionStorage.setItem('programcollapsible', state);
    },

    setupAdditionalCollapsible: function(context) {
      const self = this;

      const $tripAdditionalBlock = $(document).find('.trip-additional-block');
      const $tripAdditionalBlockTitle = $tripAdditionalBlock.find('.trip-additional-block__title');
      const $tripAdditionalBlockContent = $tripAdditionalBlock.find('.trip-additional-block__content');

      // get a unique ID for the collapsible item:
      const itemId = 'additional-collapsible-' + duo.Utils.uniqueId;

      // hide the content block and add unique ID:
      $tripAdditionalBlockContent.attr('hidden', 'true');
      $tripAdditionalBlockContent.attr('id', itemId);

      // add a toggle button to the header:
      const faqToggleButton = $(`<button type="button" class="trip-additional-block__toggle-button js-additional-toggle" aria-expanded="false" aria-controls="${ itemId }"></button>`);
      $tripAdditionalBlockTitle.prepend(`<div class="trip-additional-block__toggle-button-icon">
        <svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true" focusable="false">
          <path class="trip-additional-block__toggle-button-minus" d="M1.1 5.2c-.5 0-.8.3-.8.8s.4.8.8.8h9.8c.5 0 .8-.4.8-.8s-.4-.8-.8-.8H1.1z" />
          <path class="trip-additional-block__toggle-button-plus" d="M6.8 1.1c0-.5-.4-.8-.8-.8s-.8.3-.8.8v4.1H1.1c-.5 0-.8.3-.8.8s.4.8.8.8h4.1v4.1c0 .5.4.8.8.8s.8-.4.8-.8V6.8h4.1c.5 0 .8-.4.8-.8s-.4-.8-.8-.8H6.8V1.1z" />
        </svg>
      </div>`);
      $tripAdditionalBlockTitle.wrapInner(faqToggleButton);

      // check sessionStorage to see if the collapsible should be opened:
      const collapsibleExistingStatus = sessionStorage.getItem('additionalcollapsible');
      if(collapsibleExistingStatus === 'true') {
        const $additionalToggle = $(document).find('.trip-additional-block__toggle-button');
        const toggleButtonState = $additionalToggle.attr('aria-expanded');
        if(toggleButtonState === 'false') {
          self.toggleAdditionalCollapsible($additionalToggle);
        }
      }

      // toggle event:
      $(document).on('click.additionalcollapsible', '.js-additional-toggle', function() {
        const $toggleButton = $(this);
        self.toggleAdditionalCollapsible($toggleButton);
      });
    },

    toggleAdditionalCollapsible: function($toggleButton) {
      const controlledElementId = $toggleButton.attr('aria-controls');
      const $controlledElement = $(`#${controlledElementId}`);
      const state = $toggleButton.attr('aria-expanded') === 'false' ? true : false;

      // -> set the expanded state on the button:
      $toggleButton.attr('aria-expanded', state);
      // -> set hidden state on the content:
      if(state) {
        $controlledElement.removeAttr('hidden');
      } else {
        $controlledElement.attr('hidden', 'true');
      }
      // -> save state in sessionStorage:
      sessionStorage.setItem('additionalcollapsible', state);
    },

    setupMobileStepSummary: function(context) {

      // get the current step and print it in the mobile
      // step summary:

      let currentStepIndex = 0;
      let totalSteps = 0;
      let currentStepText = '';

      const $stepElements = $(document).find('.request-page__sticky-summary .request-summary-item');
      totalSteps = $stepElements.length;
      $stepElements.each(function(index, element) {
        const $stepElement = $(element);
        if($stepElement.hasClass('current')) {
          currentStepIndex = $stepElement.index() + 1;
          currentStepText = $stepElement.find('.request-summary-item__title-link-text').html();
        }
      });

      const $mobileSummaryTitleBlock = $(document).find('.js-request-page-sticky-summary-title');
      $mobileSummaryTitleBlock.html(`<span class="request-page-sticky-summary-infopanel__text-counter">${ currentStepIndex }/${totalSteps}</span> ${currentStepText}`);
    },

    setupVehicleCarousel: function(context) {
      const self = this;

      // find the carousel container:
      const $vehiclesCarouselContainer = $(document).find('.request-step-coach__coaches-block-list-scroller');
      // find the carousel list:
      const $vehiclesCarouselList = $vehiclesCarouselContainer.find('.request-step-coach__coaches-block-list');

      // create navigation buttons:
      const $carouselPrevButton = $(`<button type="button" class="request-step-coach__slider-navigation-button js-vehicle-carousel-navbutton" data-direction="previous">
        <span class="visually-hidden">${ Drupal.t('Previous') }</span>
        <svg width="22" height="14" viewBox="0 0 22 14" aria-hidden="true" focusable="false">
          <path d="M7 13L1 7l6-6 1.3 1.3L4.5 6H21v2H4.5l3.7 3.7L7 13z" />
        </svg>
      </button>`);
      const $carouselNextButton = $(`<button type="button" class="request-step-coach__slider-navigation-button js-vehicle-carousel-navbutton" data-direction="next">
        <span class="visually-hidden">${ Drupal.t('Next') }</span>
        <svg width="22" height="14" viewBox="0 0 22 14" aria-hidden="true" focusable="false">
          <path d="M13.8 11.7L17.5 8H1V6h16.5l-3.7-3.7L15 1l6 6-6 6-1.2-1.3z" />
        </svg>
      </button>`);
      // -> add the buttons to the page:
      const $carouselControls = $('<div class="request-step-coach__slider-navigation"></div>');
      $carouselControls.append($carouselPrevButton);
      $carouselControls.append($carouselNextButton);
      $carouselControls.insertAfter($vehiclesCarouselContainer);

      // detect if scrollbars are used:
      self._processVehicleCarouselNavigation();
      // -> recalculate on resize (with debouncing):
      let timeout = false;
      $(window).once('textcontent').on('resize.vehicleCarousel', function() {
        clearTimeout(timeout);
        timeout = setTimeout(self._processVehicleCarouselNavigation(), 250);
      });
      // -> global function to be called when a filter is toggled:
      window.requesttoolVehicleCarouselFiltered = function(){
        self._processVehicleCarouselNavigation();
        $vehiclesCarouselList.scrollLeft(0);
      };

      // detect if the browser supports smooth scroll:
      const supportsSmoothScroll = duo.Utils.supportsSmoothScroll();

      // add "js-processed" class to the scroll container:
      $vehiclesCarouselContainer.addClass('js-processed');

      // navigation event:
      $(document).on('click', '.js-vehicle-carousel-navbutton', function(e) {
        const $navButton = $(this);

        // determine the scroll amount by measuring a list-item:
        const $listItem = $(document).find('.request-step-coach__coaches-block-list > .form-item').first();
        const listItemWidth = $listItem.outerWidth(true);

        // get the scroll direction:
        const direction = $navButton.attr('data-direction');

        // set the new scroll amount:
        const currentScroll = $vehiclesCarouselList.scrollLeft();
        let newScroll = currentScroll + listItemWidth;
        if(direction === 'previous') {
          newScroll = currentScroll - listItemWidth;
        }

        // do the scroll:
        // -> alternative: duo.Utils.smoothScroll($vehiclesCarouselList[0], newScroll, true, supportsSmoothScroll);
        if(supportsSmoothScroll) {
          $vehiclesCarouselList.scrollLeft(newScroll);
        } else {
          $vehiclesCarouselList.animate({
            scrollLeft: newScroll
          }, 200);
        }
      });
    },

    _processVehicleCarouselNavigation: function() {

      // (1) check if there's a scrollbar, by measuring the container
      //     and the content; if there's no scrollbar, we don't need the navigation
      // (2) check if there are results/no results

      // (1)

      // get wrapper-width and content-width:
      const $wrapper = $('.request-step-coach__coaches-block-list-scroller');
      const $content = $('.request-step-coach__coaches-block-list');
      const wrapperWidth = $wrapper.width();
      let contentWidth = 0;
      $content.find('> .form-item:not(.hidden)').each(function(index, element) {
        const $element = $(element);
        const elementWidth = $element.width();
        contentWidth += elementWidth;
      });

      // get the navigation block:
      const $navigationBlock = $(document).find('.request-step-coach__slider-navigation');

      // configure for scroll/no-scroll:
      if(contentWidth > wrapperWidth) {
        // -> content is wider than the wrapper, there's a scroll:
        $wrapper.attr('tabindex', '0');
        $navigationBlock.removeClass('js-inactive');
      } else {
        $wrapper.removeAttr('tabindex', '');
        $navigationBlock.addClass('js-inactive');
      }

      // (2)

      // get the results block and the "no results" notice:
      const $resultsBlock = $(document).find('.request-step-coach__coaches-block');
      const $noResultsBlock = $(document).find('.request-step-coach__no-results');

      // get number of results:
      // (results are .form-item elements that are not .hidden)
      const resultCount = $content.find('> .form-item:not(.hidden)').length;
      if(resultCount === 0) {
        $noResultsBlock.removeAttr('hidden');
        $resultsBlock.attr('hidden', 'hidden');
      } else {
        $noResultsBlock.attr('hidden', 'hidden');
        $resultsBlock.removeAttr('hidden');
      }
    }
  };
})(jQuery);
